import QRCode from 'qrcodejs2'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { method } from 'lodash'


class CorrectionPayslipGenerator {

  
  constructor() {
    this.isGenerating = false
    this.container = null
  }

  async generatePayslip(studentInfo, paymentSlipInfo, status='PAID', onProgress = null, onError = null) {
    if (this.isGenerating) {
      throw new Error('payment reciepe generation already in progress')
    }

    this.isGenerating = true

      try{
        const {unit, bill_number, amount, paid_at, agent,application_status,bill_status} = paymentSlipInfo
        const {name, father_name, userID} = studentInfo
        const paymentreciepeInfo = {
          receiptType: "correction",
          name:name,
          fatherName:father_name,
          userID:userID,
          unit:unit,
          bill_number:bill_number,
          amount:amount,
          paid_at:paid_at,
          method:agent,
          status:bill_status

        };

        if (onProgress) onProgress('Preparing payment reciepe...', 35)
        this.createContainer()

      if (onProgress) onProgress('Rendering subject choice...', 50)
      this.render(paymentreciepeInfo)

      // Step 6: Wait for fonts and images to load
      if (onProgress) onProgress('Loading fonts and images...', 70)
       await this.waitForResourcesLoaded()

      // Step 7: Generate PDF
      if (onProgress) onProgress('Generating PDF...', 85)
      await this.generatePDF(paymentreciepeInfo.userID)

      // Step 8: Cleanup
          if (onProgress) onProgress('Download complete!', 100)
          this.cleanup()

          this.isGenerating = false

    } catch (error) {
        this.cleanup()
        this.isGenerating = false
        if (onError) {
          onError(error)
        }
        throw error
    }

  }

  formatDate(dateString) {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateString;
    }
  }

  formatAmount(amount) {
    if (!amount) return "N/A";
    return `${parseFloat(amount).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} BDT`;
  }

  createContainer() {
    // Remove existing container if any
    this.cleanup()

    // Create new container
    // A4 dimensions at 96 DPI (standard web DPI)
    const a4Width = 794 // 210mm in pixels
    const a4Height = 1123 // 297mm in pixels

    this.container = document.createElement('div')
    this.container.id = 'pay-slip-generator'
    this.container.style.position = 'absolute'
    this.container.style.left = '-9999px'
    this.container.style.top = '-9999px'
    this.container.style.width = a4Width + 'px'
    this.container.style.height = a4Height + 'px'
    this.container.style.backgroundColor = 'white'
    this.container.style.boxSizing = 'border-box'

    document.body.appendChild(this.container)
  }



  render(paymentreciepeInfo) {



    const html = `
<style>
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Tiro+Bangla:ital@0;1&family=Victor+Mono:ital,wght@0,500;1,500&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-size: 12px;
  line-height: 1.3;
  color: black;
}

.bangla-text { font-family: "Tiro Bangla", serif; font-weight: 400; }
.bangla-text-bold { font-family: "Tiro Bangla", serif; font-weight: 500; }
.english-text { font-family: "Roboto Condensed", sans-serif; font-weight: 400; }
.english-text-bold { font-family: "Roboto Condensed", sans-serif; font-weight: 700; }

.container {
  width: 100%;
  padding: 0 60px; /* increased from 10px */
  margin: auto;
}



  .header-wrapper {
  text-align: center;
  padding: 15px 0 30px; /* increased top/bottom padding */
  border-bottom: 2px solid #dcdcdc;
  margin-bottom: 30px;
}

/* PAYMENT RECEIPT */
.main-title {
  font-size: 28px;
  font-weight: 700;
  color: #111;
  margin-bottom: 20px;
  text-transform: uppercase;
}

/* THE FIXED CENTERING SYSTEM */
/* Old: grid-template-columns: 90px 1fr 90px; */
.middle-grid {
  display: grid;
  grid-template-columns: 90px 1fr auto; /* left logo | center | right status auto width */
  align-items: center;
  gap: 15px; /* optional spacing between columns */
  margin-bottom: 5px;
}

/* Logo */
.header-logo {
  width: 65px;
  height: auto;
  justify-self: center;
}
.logo-wrapper {
  padding-left: 35px;
}

/* Center block */
.center-block {
  text-align: center;
}

/* Company Name */
.company-name {
  font-size: 30px;
  font-weight: 700;
  color: #222;
  line-height: 1;
}

/* Subtitle */
.sub-title {
  font-size: 18px;
  font-weight: 500;
  margin-top: 5px;
  color: #444;
}

.status-box {
  border: 2px solid #444;
  border-radius: 8px;
  padding: 8px 16px; /* slightly more padding */
  font-size: 14px;
  display: block;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  background: #fafafa;
  text-transform: uppercase;
  text-align: center;
}



/* Section Boxes */
.section-box {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 25px 30px; /* increased padding inside sections */
  margin-bottom: 30px;
  /*background: #fafafa;*/
}

/* Section Title */
.section-title {
  font-size: 18px;
  font-weight: 700;
  border-bottom: 2px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 15px;
  color: #222;
}

/* Row: label + value */
.info-row {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px; /* increased spacing */
  font-size: 14px;
}

/* Label */
.info-label {
  width: 130px; /* wider for readability */
  font-weight: 700;
  color: #444;
}

/* Value */
.info-value {
  color: #111;
  font-weight: 400;
  flex: 1;
}

/* Amount special styling */
.amount-label {
  font-weight: 700;
  font-size: 16px;
}

.amount-value {
  font-weight: 700;
  font-size: 16px;
  color: #111;
}

/* Watermark styles */
.pay-slip-generator-wrapper {
  position: relative;
  overflow: hidden; /* Ensure watermark doesn't spill out */
}

.pay-slip-generator-wrapper::before {
  content: '';
  position: absolute;
  top: 70%;
  left: 50%;
  width: 100%; /* Adjust size as needed */
  height: 100%; /* Adjust size as needed */
  background-image: url('https://cu-admission.sgp1.cdn.digitaloceanspaces.com/logo/cu_watermark.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50%; /* Adjust size of the watermark */
  opacity: 0.6; /* Adjust opacity for watermark effect */
  transform: translate(-50%, -50%); /* Center the watermark */
  pointer-events: none; /* Allow interaction with content above */
  z-index: -1; /* Place it behind the content */
}

.uppercase{
  text-transform: uppercase;
}

/* Force A4 page size for print */
@page { size: A4; margin: 15mm 10mm; }
</style>

<div class="pay-slip-generator-wrapper">
  <div class="container">

    <div class="header-wrapper">

      <!-- Payment Receipt Title -->
      <div class="main-title english-text-bold">
        Payment RECEIPT
      </div>

      <!-- PERFECT ALIGNMENT ROW -->
      <div class="middle-grid">

        <!-- Left column: Logo -->
        <div class="logo-wrapper">
        <img
          src="https://cu-admission.sgp1.digitaloceanspaces.com/logo/admit_logo.png"
          class="header-logo"
          alt="Logo"
        >
        </div>

        <!-- Center column: Names -->
        <div class="center-block">
          <div class="bangla-text-bold company-name">
            চট্টগ্রাম বিশ্ববিদ্যালয়
          </div>

          <div class="sub-title english-text">
            Admission Test 2025–2026
          </div>
        </div>

        <!-- Right column: empty spacer -->
        <div class="status-box english-text">
      ${paymentreciepeInfo.status}
    </div>

      </div>

    </div>


    <!-- STUDENT INFORMATION -->
  <div class="section-box english-text">
    <div class="section-title english-text-bold">STUDENT INFORMATION</div>

    <div class="info-row">
      <div class="info-label english-text-bold">Name:</div>
      <div class="info-value">${paymentreciepeInfo.name}</div>
    </div>

    <div class="info-row">
      <div class="info-label english-text-bold">Father:</div>
      <div class="info-value">${paymentreciepeInfo.fatherName}</div>
    </div>

    <div class="info-row">
      <div class="info-label english-text-bold">User ID:</div>
      <div class="info-value">${paymentreciepeInfo.userID}</div>
    </div>
  </div>

  <!-- PAYMENT DETAILS -->
  <div class="section-box english-text">
    <div class="section-title english-text-bold">PAYMENT DETAILS</div>

    <div class="info-row">
      <div class="info-label english-text-bold">Fee Type:</div>
      <div class="info-value uppercase">correction</div>
    </div>

    <div class="info-row">
      <div class="info-label english-text-bold">Bill No:</div>
      <div class="info-value">${paymentreciepeInfo.bill_number}</div>
    </div>

    <div class="info-row">
      <div class="info-label amount-label english-text-bold">Amount:</div>
      <div class="info-value amount-value">${this.formatAmount(paymentreciepeInfo.amount)}</div>
    </div>

    <div class="info-row">
      <div class="info-label english-text-bold">Date/Time:</div>
      <div class="info-value">${this.formatDate(paymentreciepeInfo.paid_at)}</div>
    </div>

    <div class="info-row">
      <div class="info-label english-text-bold">Method:</div>
      <div class="info-value">${paymentreciepeInfo.method}</div>
    </div>
  </div>

  </div>
</div>

`
  this.container.innerHTML = html;
  }

  async waitForResourcesLoaded() {
    // Load font
    await document.fonts.load('16px "Tiro Bangla"')

    // Wait for all images to load
    const images = this.container.querySelectorAll('img')
    await Promise.all(
      Array.from(images).map((img) => {
        if (img.complete) {
          return Promise.resolve()
        }
        return new Promise((resolve, reject) => {
          img.onload = resolve
          img.onerror = () => {
            console.warn('Image failed to load:', img.src)
            resolve() // Resolve anyway to not block
          }
          // Timeout after 5 seconds
          setTimeout(resolve, 5000)
        })
      })
    )

    // Optimize images by reducing their display size
    //await this.optimizeImages()

    // Small delay to ensure everything is rendered
    await new Promise(resolve => setTimeout(resolve, 300))
  }

  async generatePDF(userid) {
  const element = this.container.querySelector('.pay-slip-generator-wrapper');

  // Render the whole content to a canvas
  const canvas = await html2canvas(element, {
    scale: 1.5,
    useCORS: true,
    backgroundColor: '#ffffff'
  });

  const imgData = canvas.toDataURL('image/jpeg', 0.85);
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgProps = pdf.getImageProperties(imgData);
  const pdfImgHeight = (imgProps.height * pdfWidth) / imgProps.width;

  let position = 0;
  let remainingHeight = pdfImgHeight;

  // Add pages
  while (remainingHeight > 0) {
    pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, pdfImgHeight);
    remainingHeight -= pdfHeight;
    position -= pdfHeight;

    if (remainingHeight > 0) {
      pdf.addPage();
    }
  }

  // ----------- Add Footer to last page -----------
  pdf.setPage(pdf.getNumberOfPages()); // go to last page
  // const footerText = 'Powered by ICT Cell, University of Chittagong';
  // pdf.setFontSize(10);
  // pdf.setFont('helvetica', 'italic');

  // // Position footer at bottom (10mm from bottom)
  // pdf.text(footerText, pdfWidth / 2, pdfHeight - 10, { align: 'center' });

  // Footer box settings
const footerHeight = 30; // increased height for multi-line
const footerPadding = 3; 
const footerX = 20;
const footerY = pdfHeight - footerHeight - 10;
const footerWidth = pdfWidth - 2 * footerX;

// Draw the bordered footer box
pdf.setDrawColor(0);
pdf.setLineWidth(0.5);
pdf.rect(footerX, footerY, footerWidth, footerHeight);

// Left side text (bold)
const leftText = "Note: This is a computer-generated receipt.\nNo signature required.\nKeep this receipt for your records and future reference.";
pdf.setFont('Roboto Condensed', 'bold');
pdf.setFontSize(12);

// Split into lines for multi-line display
const leftLines = pdf.splitTextToSize(leftText, footerWidth / 2 - footerPadding);
pdf.text(leftLines, footerX + footerPadding, footerY + 10);

// Right side text (normal)
// Right side text (Courier Prime)
// const rightText = [
//   'University of Chittagong | 2025-2026',
//   new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) // e.g., Nov 17, 2025
// ];

pdf.setFont('Roboto Condensed', 'normal'); // Courier Prime font style in jsPDF
pdf.setFontSize(12);

// Draw each line right-aligned
// rightText.forEach((line, i) => {
//   pdf.text(line, footerX + footerWidth - footerPadding, footerY + 10 + i * 6, {
//     align: 'right'
//   });
// });

 const rightText = 'University of Chittagong | 2025-2026';
 pdf.text(rightText, footerX + footerWidth - footerPadding, footerY + 10, {
     align: 'right'
   });


  // Save PDF
  const filename = `cu_payment_slip_co_${userid}.pdf`;
  pdf.save(filename);
}


  cleanup() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container)
      this.container = null
    }
  }

}

export default new CorrectionPayslipGenerator()